export const appRoles = {
  POCC_ADMIN: 'pocc-admin',
  POCC: 'pocc',
};

export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;
export const INACTIVITY_WARNING_MS = MS_PER_MINUTE;
export const MISSING_ROLES_CLAIM_ERROR = 'The access token has no roles claim';
